export enum FilterOptionEntity {
  Whitelabel = 'whitelabel',
  Client = 'client',
  Advertiser = 'advertiser',
}
